// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_i7-0";
export var actionModalContentContainer = "_i7-1";
export var createTagButton = "_i7-2";
export var footerContainer = "_i7-7";
export var fullWidthDivider = "_i7-3";
export var hasCreateTagButton = "_i7-4";
export var noCreateTagButton = "_i7-5";
export var tagsContainer = "_i7-6";
export var tagsModalContentContainer = "_i7-8";